// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qwVM","toggle":"styles_toggle__1LqBr","preview":"styles_preview__1wk-L"};